import { IAuthenticationConfig } from '@assess/browser/authentication';
import { identityTokenHeader } from '@assess/shared/http-headers';

export const authentication: IAuthenticationConfig = {
  identityToken: {
    allowedList: [window.APP_CONFIG.ASSESS_API_URL, window.APP_CONFIG.WORKFLOW_ADDRESS],
    header: identityTokenHeader,
  },
};
